import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f0eadc4e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f0eadc4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eadc4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0eadc4e')) {
      api.createRecord('f0eadc4e', component.options)
    } else {
      api.reload('f0eadc4e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f0eadc4e&scoped=true&", function () {
      api.rerender('f0eadc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/department/index.vue"
export default component.exports